<template>
  <AppLayout :title="title">
    <div class="grid grid-cols-4 gap-6 space-y-0 lg:gap-12">
      <Highlight label="Partners" :count="0" :previous-count="0" difference-label="change from previous 30 days" />
      <Highlight label="Views" :count="0" :previous-count="0" difference-label="change from previous 30 days" />
      <Highlight label="Clicks" :count="0" :previous-count="0" difference-label="change from previous 30 days" />
      <Highlight label="Leads" :count="0" :previous-count="0" difference-label="change from previous 30 days" />
    </div>

    <DataTable
      title="Partners"
      :endpoint="`copilot-insights/user/${$route.params.id}/views-by-partner`"
      :per-page="10"
      :sort="{ views: 'desc' }"
      class="mt-6 lg:mt-12"
    >
      <template v-slot:rows="rows">
        <DataTableRow v-for="(row, i) in rows" :key="i" :row="row">
          <DataTableColumn title="Partner" sortable="name">
            <router-link :to="{ name: 'copilot-insights.partner', params: { id: row.partner.id } }">{{
              row.partner.name
            }}</router-link>
          </DataTableColumn>
          <DataTableColumn title="Views" sortable="views">{{ row.views | number }}</DataTableColumn>
          <DataTableColumn title="Clicks" sortable="clicks">{{ row.clicks | number }}</DataTableColumn>
          <DataTableColumn title="Lead Intents" sortable="lead_intents">{{
            row.lead_intents | number
          }}</DataTableColumn>
          <DataTableColumn title="Leads" sortable="leads">{{ row.leads | number }}</DataTableColumn>
        </DataTableRow>
      </template>
    </DataTable>

    <DataTable
      title="Pages"
      :endpoint="`copilot-insights/user/${$route.params.id}/views-by-page`"
      :per-page="10"
      :sort="{ views: 'desc' }"
    >
      <template v-slot:rows="rows">
        <DataTableRow v-for="(row, i) in rows" :key="i" :row="row">
          <DataTableColumn title="Page" sortable="source_url">
            <div>{{ row.source_url }}</div>
            <div class="text-supplement">{{ row.partner.name }}</div>
          </DataTableColumn>
          <DataTableColumn title="Views" sortable="views">{{ row.views | number }}</DataTableColumn>
          <DataTableColumn title="Clicks" sortable="clicks">{{ row.clicks | number }}</DataTableColumn>
          <DataTableColumn title="Lead Intents" sortable="lead_intents">{{
            row.lead_intents | number
          }}</DataTableColumn>
          <DataTableColumn title="Leads" sortable="leads">{{ row.leads | number }}</DataTableColumn>
        </DataTableRow>
      </template>
    </DataTable>

    <div class="mt-12 grid gap-12 space-y-0 md:grid-cols-3">
      <Card title="Sources">
        <div class="grid grid-cols-2">
          <div>Direct / None</div>
          <div>1M</div>
          <div>Google</div>
          <div>208k</div>
          <div>Twitter</div>
          <div>56k</div>
          <div>Facebook</div>
          <div>22.3k</div>
          <div>Reddit</div>
          <div>20k</div>
        </div>
      </Card>

      <Card title="Countries">
        <div>...</div>
      </Card>

      <Card title="Languages">
        <div>...</div>
      </Card>
    </div>
  </AppLayout>
</template>

<script>
import Highlight from "@/components/Highlight.vue"

export default {
  components: { Highlight },
  metaInfo() {
    return { title: this.title }
  },
  data: () => ({
    loading: true,
    user: null,
    title: "Copilot Insights"
  }),
  async created() {
    this.loading = true
    const { data } = await this.$api.get(`users/${this.$route.params.id}`)
    this.user = data.data
    this.title = `${this.user.full_name} Copilot Insights`
    this.loading = false
  }
}
</script>
